import picturefill from 'picturefill';
import 'filepond-polyfill';

import svg4everybody from 'svg4everybody';
svg4everybody();
